import React, { PureComponent } from 'react';
import { func, string, shape } from 'prop-types';
import classnames from 'classnames';

import './Trend.scss';

export default class Trend extends PureComponent {
    static propTypes = {
        className: string,
        trend: shape({
            name: string,
        }).isRequired,
        onClick: func.isRequired,
    };

    static defaultProps = {
        className: null,
    };

    handleClick = evt => {
        const { onClick, trend } = this.props;
        if (onClick) {
            onClick(trend, evt);
        }
    };

    render() {
        const { className, trend } = this.props;
        const rootClassnames = classnames('searchBar__trends__item', className);
        return (
            <button className={rootClassnames} onClick={this.handleClick}>
                <i className="icon icon__trending" />
                {trend.name}
            </button>
        );
    }
}
